export default __webpack_public_path__ + "static/media/profile-form-email.0b0fcb3a.svg";